import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import iconlight from './images/icon-24-light@3x.svg';
import iconPrice from './images/icon-24-price@3x.svg';
import checkMark from './images/icon-16-checkmark@3x.svg';
import iconPackage from './images/icon-100-optic@3x.svg';
import PopUp from '../../../../Shared/Popup/PopUp';
import TextInput from '../../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../../Config';


const GenericDetails = (props) => {
  const discount = props.movingDiscounts?.find(({ offerType }) => offerType.value === 2)
  const packageDetails = props.movingPackagesList.find(({ contentLink }) => contentLink.id === props.selectedPackageBlockId)
  const [displayPoUpAddContact, setDisplayPoUpAddContact] = useState(false);
  const [contactDetails, setContactDetails] = useState({
    firstName: { value: props.contactDetails.firstName, error: '' },
    lastName: { value: props.contactDetails.lastName, error: '' },
    phone: { value: props.contactDetails.phone, error: '' },
  });

  const userDetails = `${props.contactDetails.firstName + " " + props.contactDetails.lastName + ", " + "טל' " + props.contactDetails.phone}`
  var isRegularTech = props.page === 'completePage' && !props.pinTechnicianDetails && props.movingWithTechnician;

  function openPopUpAddContact() {
    setDisplayPoUpAddContact(true)
  }

  function closePopUpAddContact() {
    setDisplayPoUpAddContact(false)
  }

  function onChangeContactDetails(type, value) {
    if (type == "firstName") {
      setContactDetails({ ...contactDetails, firstName: { value: value, error: '' } })
    }
    else if (type == "lastName") {
      setContactDetails({ ...contactDetails, lastName: { value: value, error: '' } })
    }
    else {
      if (contactDetails.phone.value.trim() == "" || !(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(value))) {
        setContactDetails({ ...contactDetails, phone: { value: value, error: "אנא הכנס ערך תקין" } })
      }
      else {
        setContactDetails({ ...contactDetails, phone: { value: value, error: '' } })
      }
    }
  }

  function onBtnClickAddContactDetails() {
    let isValid = true;
    if (contactDetails.firstName.value.trim().length <= 1) {
      contactDetails.firstName.error = "אנא הכנס ערך תקין";
      setContactDetails({ ...contactDetails });
      isValid = false;
    }
    if (contactDetails.lastName.value.trim().length <= 1) {
      contactDetails.lastName.error = "אנא הכנס ערך תקין";
      setContactDetails({ ...contactDetails });
      isValid = false;
    }
    if (contactDetails.phone.value.trim() == "" || !(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(contactDetails.phone.value))) {
      contactDetails.phone.error = "אנא הכנס ערך תקין";
      setContactDetails({ ...contactDetails });
      isValid = false;
    }

    if (isValid) {
      setDisplayPoUpAddContact(false)
      props.onBtnClickAddContactDetails(contactDetails);
    }
  }

  return (
    <>
      <div className={`generic-details-wrapper ${isRegularTech ? 'technician-complete' : ''}`}>
        <div className='generic-details-container'>

        {(props.movingWithTechnician && props.page === 'summaryPage' ) &&
          <div className='detail-wrapper first-block'>
            <div className='detail-title'>הכתובת החדשה</div>
            <div className='detail-subTitle'>{props.fullAddress} {props.selectedEntry && 'כניסה: ' + props.selectedEntry}</div>
          </div> }

          {(props.movingWithTechnician && props.page === 'summaryPage' ) &&
            <div className='detail-wrapper first-block'>
              <div className='detail-title'>הטכנאי יגיע לבית החדש</div>
              <div className='detail-subTitle'>{"ביום " + props.technicianData.selectedTechnicianTimeSlot?.fullDate}</div>
            </div>
          }

          {(props.movingWithTechnician && props.page === 'summaryPage' && props.selectedPackageBlockId === null) &&
            <div className='detail-wrapper first-block'>
              <div className='detail-title'>המוצרים שעוברים</div>
              {props.selectedProducts?.map((item, index) => {
                return (<div key={index} className='detail-product'>
                  {item.bundleType == "Triple" || item.bundleType == "Quattro" ?
                    <>
                      <div className='detail-subTitle'>{item.bundleType == "Triple" ? "טריפל : " : "קוונטרו :"} {item.productDescription}</div>
                      <div className='detail-subTitle'>כתובת נוכחית: {item.fullAddress}</div>
                    </>
                    :
                    <>
                      <div className='detail-subTitle'>{item.productDescription}</div>
                      {item.productType == "TV" && <div className='detail-subTitle'>{item.email}</div>}
                      {item.productType == "Mapa" && <div className='detail-subTitle'>{item.phoneNumber}</div>}
                      {(item.productType != "TV" || item.productType == "TV" && item.equipment) && <div className='detail-subTitle'>כתובת נוכחית: {item.fullAddress}</div>}
                    </>}
                </div>)
              })}
            </div>
          }


          {props.movingWithTechnician && <>

              {/* <div className='info'>
                <img className='info-img' src={iconlight} />
                <div className='info-text'>בזמן ביקור הטכנאי, חייב להיות בבית מבוגר מעל גיל 18</div>
              </div> */}
            {/* </div> */}

            {/* {discount?.isDisplayOffer?.value &&
              <div className='detail-wrapper'>
                <div className='info'>
                  <img className='info-img' src={Config.epiBaseUrl + discount.iconImage.value?.url} />
                  <div className='info-text'>{discount.offerText?.value}</div>
                </div>
              </div>
            }
            <div className='divider'></div> */}



            {props.selectedPackageBlockId != null &&
              <div className='detail-wrapper-package'>
                <div className='detail-package-icon'><Image src={iconPackage} /></div>
                <div className='detail-title'>החבילה החדשה שלך</div>
                <div className='detail-subTitle' dangerouslySetInnerHTML={{ __html: packageDetails.title.value }}></div>
                <div className='detail-packageBox'>
                  <div><Image src={checkMark} /> {packageDetails.routerText.value}</div>
                </div>
                <div className='detail-packageBox-price'>{packageDetails.price.value}₪ לחודש</div>
              </div>
            }

            {props.chargeable && <div className='chargeable-box'>עלות דמי פריסת התשתית {props.paving.pavingFee}₪ עבור 3 שנים</div>}


            <div className='divider discount-top'></div>
            <div className='detail-wrapper discount'>
            {/* <div className='info'>
              <img className='info-img' src={iconPrice} />
              <div className='info-text discount'>קיבלת מאיתנו חצי חודש במתנה!</div>
            </div> */}
          </div>
          <div className='divider'style={{ marginTop: '20px'}}></div>

          <div className={`detail-wrapper ${props.page === 'completePage' ? 'complete' : ''}`} style={{ marginBottom: '0px'}}>
            <div className='detail-title'>חשוב לנו להדגיש</div>
              <div className='info'>
                <Image className='info-img' src={iconlight} />
                <div className='info-text'>בזמן ביקור הטכנאי, חייב להיות בבית מבוגר מעל גיל 18</div>
              </div>
              <div className='info'>
                <Image className='info-img' src={iconlight} />
                <div className='info-text regular'>לקראת ביקור הטכנאי יש להעביר את כל הציוד של {window.Config.brand_Name_HE} מהדירה הישנה לדירה החדשה</div>
              </div>
          </div>


          {props.movingWithTechnician && props.page === 'summaryPage' &&
          <>
              <div className='divider'></div>
              <div className='detail-wrapper'>
                  <div className='detail-title'>פרטים ליצירת קשר</div>
                  <div className='detail-subTitle'>{userDetails}</div>
                  {props.page === 'summaryPage' &&
                    <button className='open-popup-btn' onClick={() => openPopUpAddContact()}>לשינוי פרטי יצירת קשר</button>
                  }
              </div>
            </>
            }


            {props.page === 'completePage' &&
              props.pinTechnicianDetails?.isTechnician ?
              <>
                <div className='detail-full-width'>ייתכן וניצור איתך קשר על מנת להשלים פרטים חסרים</div>
              </>
              : null
              // <>
              //   {
              //     props.invoicingDeliveryType == 'email' &&
              //     <div className='detail-wrapper'>
              //       <div className='detail-title'>לאיזה מייל לשלוח את סיכום ההזמנה?</div>
              //       <div className='detail-subTitle'>{props.email.value}</div>
              //     </div>
              //   }
              //   {
              //     props.invoicingDeliveryType == 'phone' &&
              //     <div className='detail-wrapper'>
              //       <div className='detail-title'>הסיכום ישלח אליך לטלפון</div>
              //       <div className='detail-subTitle'>{props.phoneNumber.value}</div>
              //     </div>
              //   }
              // </>
            }

            {/* <div className='divider'></div> */}

          </>}
        </div>
      </div>
      <PopUp showPopUp={displayPoUpAddContact} onClose={() => closePopUpAddContact()} className="add-contact-details-popup">
        <h2>מי יהיה בבית כשהטכנאי יגיע?</h2>
        <TextInput
          value={contactDetails.firstName.value}
          onChange={(e) => onChangeContactDetails('firstName', e.target.value)}
          type='text'
          required='required'
          placeholder='שם פרטי'
          error={contactDetails.firstName.error}
        />
        <TextInput
          value={contactDetails.lastName.value}
          onChange={(e) => onChangeContactDetails('lastName', e.target.value)}
          type='text'
          required='required'
          placeholder='שם משפחה'
          error={contactDetails.lastName.error}
        />
        <TextInput
          value={contactDetails.phone.value}
          onChange={(e) => onChangeContactDetails('phone', e.target.value)}
          type='tel'
          required='required'
          placeholder='טלפון נייד'
          maxLength='11'
          error={contactDetails.phone.error}
        />
        <BtnSubmit
          text={'עדכון'}
          onclick={() => onBtnClickAddContactDetails()}
          formid='moving'
        />
      </PopUp>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.movingBlock.movingApartmentData.page,
    selectedProducts: state.movingBlock.movingApartmentData.selectedProducts,
    movingWithTechnician: state.movingBlock.movingApartmentData.movingWithTechnician,
    technicianData: state.movingBlock.movingApartmentData.technicianData,
    selectedEntry: state.movingBlock.movingApartmentData.address?.selectedEntry?.entry,
    userDetails: state.authentication.loginData.userDetails,
    contactDetails: state.movingBlock.movingApartmentData.contactDetails,
    invoicingDeliveryType: state.movingBlock.movingApartmentData.invoicingDeliveryType,
    email: state.movingBlock.movingApartmentData.email,
    phoneNumber: state.movingBlock.movingApartmentData.phoneNumber,
    movingDiscounts: state.movingBlock.movingEpiData.movingDiscounts?.expandedValue,
    chargeable: state.movingBlock.movingApartmentData.paving?.chargeable,
    paving: state.movingBlock.movingApartmentData.paving,
    movingPackagesList: state.movingBlock.movingEpiData.movingPackagesList?.expandedValue,
    selectedPackageBlockId: state.movingBlock.movingApartmentData.selectedPackageBlockId,
    pinTechnicianDetails: state.movingBlock.movingApartmentData.pinTechnicianDetails,
    isCheckedUpdateDeliveryAddress: state.movingBlock.movingApartmentData.isCheckedUpdateDeliveryAddress
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericDetails);

